/**
 * Settings Context Provider
 *
 * Context provider for sharing settings state across the admin interface.
 *
 * @since 1.0.0
 */

import { __ } from '@wordpress/i18n';
import React, { createContext, useContext } from 'react';

import type { UseSettingsReturn } from '@/admin/hooks';

import { useSettings } from '../../hooks/use-settings';
import type { SettingsContextType, SettingsProviderProps } from './types';

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export const useSettingsContext = (): UseSettingsReturn => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error(
      __('useSettingsContext must be used within a SettingsProvider', 'redfox-added-to-cart-popup')
    );
  }
  return context;
};

export const SettingsProvider: React.FC<SettingsProviderProps> = ({ children }) => {
  const settingsData = useSettings();

  return <SettingsContext.Provider value={settingsData}>{children}</SettingsContext.Provider>;
};
